import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.list.length
    ? _c(
        "div",
        [
          _c("div", { staticClass: "text-h6 text--text pa-2" }, [
            _vm._v("\n    " + _vm._s(_setup.translatedTitle) + "\n  "),
          ]),
          _vm._v(" "),
          _c(
            VList,
            _vm._l(_vm.list, function (item, index) {
              return _c(
                VListItem,
                {
                  key: index,
                  on: {
                    click: function ($event) {
                      return _setup.handleClickItem(item)
                    },
                  },
                },
                [
                  _c(VListItemContent, { staticClass: "py-2" }, [
                    _c(
                      "div",
                      { staticClass: "text-body-1 text--text text-break" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              item.isWorkplace
                                ? _setup.transDynamic(
                                    item.workplace?.spec,
                                    `name,${_setup.currentLanguageIso},${_setup.needTranslate}`
                                  )
                                : _setup.transDynamic(
                                    item.service,
                                    `name,${_setup.currentLanguageIso},${_setup.needTranslate}`
                                  )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-body-2 text-secondary--text" },
                      [
                        item.isWorkplace &&
                        _setup.getPriceList(item.workplace).priceClub &&
                        _setup.filterType === "clinic"
                          ? _c(
                              "span",
                              { staticClass: "text-error--text mr-1" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _setup.getFormattedPrice(
                                      _setup.getPriceList(item.workplace)
                                        .priceClub
                                    )
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.isWorkplace
                          ? _c(
                              "span",
                              {
                                class: {
                                  "text-decoration-line-through":
                                    _setup.getPriceList(item.workplace)
                                      .priceClub &&
                                    _setup.filterType === "clinic",
                                  "text-success--text":
                                    item.workplace
                                      ?.tab_is_free_with_treatment &&
                                    _setup.filterType === "clinic",
                                },
                              },
                              [_vm._v(_vm._s(_setup.formattedPrice(item)))]
                            )
                          : _c("span", [_vm._v(_vm._s(item.price))]),
                        _vm._v(" "),
                        item.agesText && item.isWorkplace
                          ? [
                              _c(
                                "span",
                                { staticClass: "bg-gray-80--text mx-1" },
                                [_vm._v("•")]
                              ),
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.agesText) +
                                  "\n          "
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    VListItemIcon,
                    { staticClass: "align-self-auto" },
                    [
                      _c(VIcon, [
                        _vm._v("\n          ui-icon-arrow-right\n        "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }